import { render, staticRenderFns } from "./clients-list.vue?vue&type=template&id=48e489ec&scoped=true"
import script from "./clients-list.vue?vue&type=script&lang=js"
export * from "./clients-list.vue?vue&type=script&lang=js"
import style0 from "./clients-list.vue?vue&type=style&index=0&id=48e489ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e489ec",
  null
  
)

export default component.exports